import { get } from "../../../logics/src/utils/helpers";
import { getUrl, ROUTES } from 'api/urls';
import { logger } from 'logging';
import { ApiHelper } from 'api';
import { contentTypes } from 'constants/requestHeaders';
import { addressTransformer, addAddressFashionTransformer, editAddressTransformer, addressTransformerFashion, editAddressFashionTransFormer, addressTransformerGrahak, addAddressGrahakTransformer, editAddressGrahakTransFormer } from '../transformers/addressTransformer';
import { addressServiceabilityForFashion, autoAddressTransformer, postCodeTransformer } from '../transformers/autoAddressTransformer';
import { geoAddressTransformer } from '../transformers/geoAddressTransformer';
import { METHODS } from './constant';
import { transformConfigFlag } from '../transformers/configFlagsTransformer';
import { STATUS } from 'layouts/Payment/common/dependencies/constants';
import { checkIsRewardPointsEnabled } from 'layouts/Payment/common/dependencies/dependencyhelpers';
import { toLowerCase } from "logics/src/utils/toLowerCase";
import { getAppVersion } from './../../../helpers/appVersion';
import { cartInfoCallback } from "wrapper/PaymentWrapper/dependencies/helper";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { trackErrorInlineMessage } from "layouts/Payment/common/dependencies/tracking";
import { PAGE_TYPES } from "constants/index";
import { STATUS_CODE } from "api/constants";
import { getServiceableHeader } from "../../../helpers/index";
import { queryStringFromParams } from  "../../../helpers/utils/url";
import { importAddressTransformer } from "../transformers/importAddressTransformer";
import { importAndSaveAddressTransformer } from "../transformers/importAndSaveAddressTransformer";


const defaultParams = {
  source: 'react',
  appVersion: getAppVersion(),
  domain: __PLATFORM__,
  catalog_tag_filter: __PLATFORM__,
};

const DEFAULT_ERROR_MESSAGE = 'Error in Address/Service: ';
const DEFAULT_WARN_MESSAGE = 'Warning in Address/Service: ';

export const getConfigFlags = async () => {
  const queryParams = {
    ...defaultParams,
  };

  const url = getUrl(ROUTES.CONFIG_FLAGS);

  try {
    if (url) {
      // const response = paymentInfoJSon;
      const { data: response } = await ApiHelper(
        url,
        METHODS.GET,
        queryParams,
        {
          'Content-Type': contentTypes.JSON,
        },
        {
          CSRF: true,
        }
      );
      if (get(response, 'success')) {
        return transformConfigFlag(response.data);
      }
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'getConfigFlags'), {errorResponse: response});
      return response;
    }
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}getConfigFlags`);
  }
};

export const getAllAddress = async () => {
  const url = getUrl(ROUTES.GET_ALL_ADDRESS);
  const formData = new FormData();
  formData.append('source', defaultParams.source);
  formData.append('app_version', defaultParams.appVersion);
  formData.append('catalog_tag_filter', defaultParams.catalog_tag_filter);
  try {
    const serializeFormData = new URLSearchParams(formData).toString();
    // const response = allAddressJson;
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      serializeFormData,
      {
        'Content-Type': contentTypes.URL_ENCODED,
      },
      {
        CSRF: true,
      }
    );
    if (get(response, 'status') === 'success') {
      return addressTransformer(response.response);
    }
    logger.error(new Error(DEFAULT_WARN_MESSAGE + 'getAllAddress'), {errorResponse: response});
    return response;
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}getAllAddress`);
  }
};

export const getAllAddressFashion = async () => {
  
  const url = getUrl(ROUTES.GET_ALL_ADDRESS_FOR_NON_BEAUTY_PLATFORM);

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'get',
      // serializeFormData,
      {
        'Content-Type': contentTypes.URL_ENCODED,
      },
      {
        'x-web': 1, // This is required for fashion
        CSRF: true,
      }
    );
    if (get(response, 'status')?.toLowerCase() === 'success') {
      return addressTransformerFashion(response?.response);
    }
    logger.error(new Error(DEFAULT_WARN_MESSAGE + 'getAllAddress'), {errorResponse: response});
    return response;
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}getAllAddress`);
  }
};

export const addNewAddress = async (params: FormData) => {
  params.append('source', 'react');
  params.append('app_version', getAppVersion());
  params.append('catalog_tag_filter', defaultParams.catalog_tag_filter);

  const url = getUrl(ROUTES.ADD_NEW_ADDRESS);

  try {
    const serializeFormData = new URLSearchParams(params).toString();

    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      serializeFormData,
      {
        'Content-Type': contentTypes.URL_ENCODED,
      },
      {
        CSRF: true,
      }
    );
    if (get(response, 'status') === 'success') {
      return response.response;
    }
    logger.error(new Error(DEFAULT_WARN_MESSAGE + "addNewAddress"), {
      errorResponse: response,
      ny_city: params.get("city"),
      ny_state: params.get("state"),
      postcode: params.get("postcode"),
    });
    return response;
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}addNewAddress`);
  }
};

/**
 * Since it might have PI, this is a temp block
 * which can be remove later once the issue is resolved
 * this is remoteconfig driven, once issue is figured out, it will be disabled from switch
 */
const isLogAddressFailuresEnabled = () => {
  try {
    const isEnabled = !!(window?.remoteConfig?.switches?.isLogAddressFailuresEnabled)
    return isEnabled;
  } catch (error) {
    logger.error(error, 'Error in isLogAddressFailuresEnabled');
    return false;
  }
}

export const addNewAddressFashion = async (params: FashionAddAddressParams) => {
  const url = getUrl(ROUTES.ADD_NEW_ADDRESS_FOR_NON_BEAUTY_PLATFORM);
  const serializeFormData: any = JSON.stringify(params);

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      serializeFormData,
      {
        'x-web': 1, // This is required for fashion
        'Content-Type': contentTypes.JSON,
        'X-ONEREWARD' : checkIsRewardPointsEnabled(),
        ...getServiceableHeader()
      },
      {
        CSRF: true,
      }
    );

    if (get(response, 'status')?.toLowerCase() === 'success') {
      return addAddressFashionTransformer(response);
    }
    logger.error(new Error(DEFAULT_WARN_MESSAGE + 'addNewAddressFashion'), {errorResponse: response});
    /**
     * this is a temporary block added logger added to log the req if api fails
     * this block will be removed once the issue is resolved
     * we will log the request if the api fails
     */
    if(isLogAddressFailuresEnabled()){
      logger.error(new Error("Add new Address Failure"), {request: params});
    }
    
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}addNewAddressFashion`);
    /**
     * this is a temporary block added logger added to log the req if api fails
     * this block will be removed once the issue is resolved
     * we will log the request if the api fails
     */
    if(isLogAddressFailuresEnabled()){
      logger.error(new Error("Add new Address Failure"), {request: params});
    }
  }
};

export const editAddress = async (params: FormData) => {
  const url = getUrl(ROUTES.EDIT_ADDRESS);
  params.append('source', 'react');
  params.append('app_version', getAppVersion());
  params.append('catalog_tag_filter', defaultParams.catalog_tag_filter);

  try {
    const serializeFormData = new URLSearchParams(params).toString();
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      serializeFormData,
      {
        'Content-Type': contentTypes.URL_ENCODED,
      },
    );
    if (get(response, 'status') !== 'success') {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'editAddress'), {errorResponse: response});
    }
    return editAddressTransformer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}editAddress`);
  }
};

export const editAddressFashion = async (params: FashionEditAddressParams) => {
  const url = getUrl(ROUTES.EDIT_ADDRESS_FOR_NON_BEAUTY_PLATFORM);
  const method = 'post';
  const serializeFormData = JSON.stringify(params);
  
  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      method,
      serializeFormData,
      {
        'x-web': 1, // This is required for fashion
        'Content-Type': contentTypes.JSON,
      }
    );

    if (get(response, 'status') !== 'success') {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'addNewAddressFashion'), {errorResponse: response});
    }

    return editAddressFashionTransFormer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}addNewAddressFashion`);
  }
};

export const setAddress = async (params:ISetAddress, isConvenienceChargesEnabled: boolean) => {
  /**
   * cart refresh and setAddress api response is same.
   */
  const url = getUrl(ROUTES.SET_ADDRESS);
  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      {...params, ...defaultParams},
      {
        'Content-Type': contentTypes.JSON,
        'X-ONEREWARD' : checkIsRewardPointsEnabled(),
        "X-APPLY-CART-CHARGES": !!isConvenienceChargesEnabled,
        ...getServiceableHeader()
      },
      {
        CSRF: true,
      }
    );
    
    if (!get(response, 'success')) {
      
      trackErrorInlineMessage({
        error_code: response?.code || 500,
        error_message: response.message || PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG,
        interaction_location: PAGE_TYPES.ADDRESS_PAGE,
      });

      logger.error(new Error(DEFAULT_WARN_MESSAGE + "setAddress"), { errorResponse: response });
      const err = new Error(response?.message || DEFAULT_ERROR_MESSAGE) as IError;

      if (
        response?.statusCode === STATUS_CODE.ADDRESS_NOT_SERVICEABILITY_FASHION ||
        response?.statusCode === STATUS_CODE.ADDRESS_NOT_SERVICEABILITY_BEAUTY
      ) {
        err.code = response?.statusCode;
      }

      throw err;
    }

    const transformedCartData =  cartInfoCallback(response);
    if(!transformedCartData){
      throw new Error(response?.message || DEFAULT_ERROR_MESSAGE);
    }
    return transformedCartData;
    
  } catch (error: any) {
    
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}setAddress`);
    const err = new Error(error?.message || DEFAULT_ERROR_MESSAGE) as IError;
    if(error?.code){
      err.code = error?.code;
    }

    throw err;
  }
};

export const setAddressGuest = async (params:ISetAddressGuest, isConvenienceChargesEnabled: boolean) => {
  /**
   * cart refresh and setAddress api response is same.
   */
  const url = getUrl(ROUTES.SET_ADDRESS_GUEST);
  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      {...params, ...defaultParams},
      {
        'Content-Type': contentTypes.JSON,
        'X-ONEREWARD' : checkIsRewardPointsEnabled(),
        "X-APPLY-CART-CHARGES": !!isConvenienceChargesEnabled,
        ...getServiceableHeader()
      },
      {
        CSRF: true,
      }
    );
    if (!get(response, 'success')) {
      
      trackErrorInlineMessage({
        error_code: response?.code || 500,
        error_message: response.message || PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG,
        interaction_location: PAGE_TYPES.ADDRESS_PAGE,
      });
      logger.error(new Error(DEFAULT_WARN_MESSAGE + "setAddress"), { errorResponse: response });
      const err = new Error(response?.message || DEFAULT_ERROR_MESSAGE) as any;

      if (
        response?.statusCode === STATUS_CODE.ADDRESS_NOT_SERVICEABILITY_FASHION ||
        response?.statusCode === STATUS_CODE.ADDRESS_NOT_SERVICEABILITY_BEAUTY
      ) {
        err.code = response?.statuscode;
      }

      throw err;
    }

    const transformedCartData =  cartInfoCallback(response);
    if(!transformedCartData){
      throw new Error(response?.message || DEFAULT_ERROR_MESSAGE);
    }
    return transformedCartData;
    
  } catch (error:any) {

    logger.error(error, `${DEFAULT_ERROR_MESSAGE}setAddress`);
    const err = new Error(error?.message || DEFAULT_ERROR_MESSAGE) as IError;
    if(error?.code){
      err.code = error?.code;
    }

    throw err;
  }
};

export const getAddressServiceability = async (params: FormData) => {
  params.append('source', 'react');
  params.append('catalog_tag_filter', defaultParams.catalog_tag_filter);


  const url = getUrl(ROUTES.ADDRESS_SERVICABILITY);
  const serializeFormData = new URLSearchParams(params).toString();

  try {
    const serializeFormData = new URLSearchParams(params).toString();
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      serializeFormData,
      {
        'Content-Type': contentTypes.URL_ENCODED,
      },
      {
        CSRF: true,
      }
    );

    if (get(response, 'status') !== toLowerCase(STATUS.SUCCESS)) {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'getAddressServicability'), {errorResponse: response});
    }
    const transformedResponse = autoAddressTransformer(response);
    /** 
     * log  country, state or city if status is success and country, state or city is not present
     */
    if (
      get(response, "status") === toLowerCase(STATUS.SUCCESS) &&
      (!transformedResponse?.city || !transformedResponse?.state || !transformedResponse?.country)
    ) {
      const err = new Error("Error while getting country, state or city");
      logger.error(err, {
        pincode: params.get("pincode"),
        errorResponse: response,
        ny_country: transformedResponse?.country,
        ny_state: transformedResponse?.state,
        ny_city: transformedResponse?.city,
      });
    }

    return transformedResponse;
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}getAddressServicability`);
  }
};

/**
 * This is for Fashion and footlocker
 * It will replace the postcode api
 */
export const serviceabilityForFashionPlatform = async (serviceabilityForFashionParams: IServiceabilityForFashionParams) => {
  const serviceabilityForFashionQueryParams = {
    ...defaultParams,
    pincode: serviceabilityForFashionParams.pincode,
    countryCode: 'IN' // This is required and should be hardcoded to IN
  }
  /**
   * This is a temporary block added where domain value will be overriden for fashion as nykaaFashion
   * This is being fixed by BE, once fixed this block will be removed
   */
  if(__PLATFORM__ === 'fashion'){
    serviceabilityForFashionQueryParams.domain = 'nykaaFashion';
    serviceabilityForFashionQueryParams.catalog_tag_filter = 'nykaaFashion';
  }
  const url = getUrl(ROUTES.ADDRESS_SERVICEABILITY_FOR_NON_BEAUTY_PLATFORM);
  const queryString = queryStringFromParams(serviceabilityForFashionQueryParams);

  try {
    const { data: response } = await ApiHelper(
      `${url}${queryString}`,
      'get',
      serviceabilityForFashionQueryParams,
      {
        'Content-Type': contentTypes.JSON,
      },
      {
        CSRF: true,
      }
    );
    if (!get(response, 'success')) {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'serviceabilityForFashionPlatform'), {errorResponse: response});
    }

    return addressServiceabilityForFashion(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}serviceabilityForFashionPlatform`);
  }
};


//for fashion to fetch state and city based on pincode
export const postCode = async (serviceabilityForFashionParams: IServiceabilityForFashionParams) => {
  const url = getUrl(ROUTES.POSTCODE);
  const serviceabilityForFashionQueryParams = {
    pincode: serviceabilityForFashionParams.pincode,
    deviceType: serviceabilityForFashionParams.deviceType,
  }

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      serviceabilityForFashionQueryParams,
      {
        'Content-Type': contentTypes.JSON,
      },
      {
        CSRF: true,
      }
    );
    if (get(response, 'status') !== toLowerCase(STATUS.SUCCESS)) {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'postCode'), {errorResponse: response});
    }

    return postCodeTransformer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}postCode`);
  }
};


export const getGeoAddress = async (params: any) => {
  const { lattitude, longitude } = params;

  try {
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: parseFloat(lattitude), lng: parseFloat(longitude) };
    const response = await geocoder.geocode({ location: latlng });
    return geoAddressTransformer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}getCurrentLocationAddress`);
    throw error;
  }
};

export const importAddress = async () => {
  const url = getUrl(ROUTES.IMPORT_ADDRESS);
  const addressImportParams = {
    ...defaultParams
  }

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'get',
      addressImportParams,
      {
        'Content-Type': contentTypes.JSON,
      },
      {
        CSRF: true,
      }
    );
    // const response = data1;
    if (get(response, 'status') !== toLowerCase(STATUS.SUCCESS)) {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'getAddressImport'), {errorResponse: response});
    }

    return importAddressTransformer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE} getAddressImport`);
    throw error;
  }
};

export const importAndSaveAddress = async (selectedAddressIds: any) => {
  const url = getUrl(ROUTES.SAVE_IMPORTED_ADDRESS);
  const importAndSaveParams = {
    addressIds: selectedAddressIds,
    ...defaultParams
  }

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      'post',
      importAndSaveParams,
      {
        'Content-Type': contentTypes.JSON,
      },
      {
        CSRF: true,
      }
    );
    // const response = data2;
    if (get(response, 'status') !== toLowerCase(STATUS.SUCCESS)) {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'importAndSaveAddress'), {errorResponse: response});
    }

    return importAndSaveAddressTransformer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE} importAndSaveAddress`);
    throw error
  }
};


export const getAllAddressGrahak = async () => {
  let url = getUrl(ROUTES.GRAHAK_ALL_ADDRESS);

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      "get",
      // serializeFormData,
      {
        "Content-Type": contentTypes.URL_ENCODED,
      },
      {
        "x-web": 1, // This is required for fashion
        CSRF: true,
      }
    );
    if (get(response, "status")?.toLowerCase() === "success") {
      return addressTransformerGrahak(response?.data);
    }

    logger.error(new Error(DEFAULT_WARN_MESSAGE + "getAllAddressGrahak"), { errorResponse: response });
    return response;
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}getAllAddressGrahak`);
  }
};

export const addNewAddressGrahak = async (params: IGrahakAddAddressParams) => {
  const url = getUrl(ROUTES.GRAHAK_ADD_NEW_ADDRESS);
  const serializeFormData = JSON.stringify(params);

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      "post",
      serializeFormData,
      {
        "x-web": 1, // This is required for fashion
        "Content-Type": contentTypes.JSON,
        "X-ONEREWARD": checkIsRewardPointsEnabled(),
        ...getServiceableHeader(),
      },
      {
        CSRF: true,
      }
    );

    if (get(response, "status")?.toLowerCase() === "success") {
      return addAddressGrahakTransformer(response);
    }
    logger.error(new Error(DEFAULT_WARN_MESSAGE + "addNewAddressGrahak"), {
      errorResponse: response,
    });
    /**
     * this is a temporary block added logger added to log the req if api fails
     * this block will be removed once the issue is resolved
     * we will log the request if the api fails
     */
    if (isLogAddressFailuresEnabled()) {
      logger.error(new Error("Grahak Add new Address Failure"), { request: params });
    }
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}addNewAddressGrahak`);
    /**
     * this is a temporary block added logger added to log the req if api fails
     * this block will be removed once the issue is resolved
     * we will log the request if the api fails
     */
    if (isLogAddressFailuresEnabled()) {
      logger.error(new Error("Grahak Add new Address Failure"), { request: params });
    }
  }
};

export const editAddressGrahak = async (params: IGrahakEditAddressParams) => {

  const addressId = params?.addressId;
  const url = `${getUrl(ROUTES.GRAHAK_EDIT_ADDRESS)}/${addressId}`;
  const method = 'put';
  const serializeFormData = JSON.stringify(params)

  try {
    const { data: response } = await ApiHelper(
      `${url}`,
      method,
      serializeFormData,
      {
        'x-web': 1, // This is required for fashion
        'Content-Type': contentTypes.JSON,
      }
    );

    if (get(response, 'status') !== 'success') {
      logger.error(new Error(DEFAULT_WARN_MESSAGE + 'editAddressGrahak'), {errorResponse: response});
    }

    return editAddressGrahakTransFormer(response);
  } catch (error) {
    logger.error(error, `${DEFAULT_ERROR_MESSAGE}editAddressGrahak`);
  }
};
